export const HEADER_COLOR = '#D3D3D3';
export const OUTER_BORDER_COLOR = '#1476ED';
export const OUTER_BORDER_WIDTH = 0.5;
export const INNER_BORDER_COLOR = "#000000";
export const INNER_BORDER_WIDTH = 0.25;
export const PAGE_BORDER_WIDTH = 6;
export const FULL_WIDTH = 216 - PAGE_BORDER_WIDTH * 2;
export const FULL_HEIGHT = 279 - PAGE_BORDER_WIDTH * 2;
export const SECTION_GAP_WIDTH = 3;

export const HEADER_WIDTH = FULL_WIDTH;
export const HEADER_LEFT = PAGE_BORDER_WIDTH;
export const HEADER_TOP = PAGE_BORDER_WIDTH;
export const ROW_SECTION_HEADER_HEIGHT = 4;
export const THIN_LINE = 0.25;
export const THICK_LINE = 0.5;

export const HEADER_1_SIZE = 9;
export const HEADER_2_SIZE = 7;
export const LOGO_LEFT = PAGE_BORDER_WIDTH;
export const LOGO_TOP = PAGE_BORDER_WIDTH;
export const LOGO_WIDTH = 50;
export const LOGO_HEIGHT = 23;

export const OPERATOR_LEFT = PAGE_BORDER_WIDTH;
export const OPERATOR_TOP = PAGE_BORDER_WIDTH + LOGO_HEIGHT + SECTION_GAP_WIDTH;
export const OPERATOR_HEIGHT = 22;
export const OPERATOR_WIDTH = FULL_WIDTH;

export const DATA_TOP = OPERATOR_HEIGHT + OPERATOR_TOP + SECTION_GAP_WIDTH;
export const DATA_LEFT = PAGE_BORDER_WIDTH;
export const DATA_WIDTH = FULL_WIDTH;
export const DATA_ROW_HEIGHT = 4;

export const FOOTER_TOP = FULL_HEIGHT - 20;
export const FOOTER_LEFT = PAGE_BORDER_WIDTH;
export const FOOTER_WIDTH = FULL_WIDTH;
export const FOOTER_HEIGHT = 10;

export const PAGE_NUM_TOP = FOOTER_TOP + FOOTER_HEIGHT + 1;
export const PAGE_NUM_HEIGHT = FULL_HEIGHT - PAGE_NUM_TOP + 3;
export const DATA_HEIGHT = FOOTER_TOP - DATA_TOP - SECTION_GAP_WIDTH;




// WEBPACK FOOTER //
// ./src/Services/Pdf/TruckTicket/SpecMilsTruckTicket.ts